import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import type {MuscleId} from '../../domain/muscle-id.value-object';

export class MuscleIdValidator implements Validator<MuscleId> {
  readonly standardSchema = z.templateLiteral(['msc', '_', z.string().min(1)]);

  validate(value: unknown): Result<MuscleId, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(
        new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid muscle id.'),
      );
    }
    return ok(parsed.data);
  }
}
